import { SipPlanMode } from '../api/types'
import { IdealSipPlansListErrorState } from './body/ideal/IdealSipPlansListErrorState'
import { SipIdealBody } from './body/ideal/SipIdealBody'
import { SipPlansFooter } from './footer/SipPlansFooter'
import { PlansListChrome } from '../../lumpsum/plans-list/header/common/PlansListChrome'
import { SipIdealContextBar } from './header/ideal/SipIdealContextBar'
import {
  resolveSipIdealHeaderAppearance,
  SipIdealHeader
} from './header/ideal/SipIdealHeader'
import {
  isSipIdealPlansFetchFailed,
  isSipIdealPlansLoading,
  useSipPlansContext
} from './SipPlansProvider'
import { PlansCategoryListSkeleton } from '../../lumpsum/plans-list/lumpsum-ui-components/PlansCategoryListSkeleton'
import { isSipPlanRolledOut } from './timer/shared/planStatus'
import { SipIdealTimerPanel } from './timer/ideal/SipIdealTimerPanel'

/** Ideal SIPs tab: timer/strategy shell vs normal plan slots. */
export function SipIdealPageContent() {
  const { plansOverview, plansQuery, markTimerResumeRefetch } = useSipPlansContext()
  const chromeBackground = resolveSipIdealHeaderAppearance(
    plansOverview?.riskProfile
  ).chromeBackground

  if (isSipIdealPlansLoading(SipPlanMode.IDEAL_SIPS, plansOverview != null, plansQuery)) {
    return (
      <>
        <PlansListChrome background={chromeBackground}>
          <SipIdealHeader />
        </PlansListChrome>
        <PlansCategoryListSkeleton />
      </>
    )
  }

  if (isSipIdealPlansFetchFailed(SipPlanMode.IDEAL_SIPS, plansQuery)) {
    return <IdealSipPlansListErrorState onRetry={plansQuery.refetch} />
  }

  if (!isSipPlanRolledOut(plansOverview?.planStatus)) {
    return (
      <SipIdealTimerPanel
        planStatus={plansOverview?.planStatus}
        timeToPlanDrop={plansOverview?.timeToPlanDrop}
        isSubscriptionEligible={plansOverview?.isPlanSubscriptionEligible === true}
        strategyCta={plansOverview?.strategyCta}
        refetchPlan={() => {
          markTimerResumeRefetch()
          void plansQuery.refetch()
        }}
      />
    )
  }

  return (
    <>
      <PlansListChrome background={chromeBackground}>
        <SipIdealHeader />
        <SipIdealContextBar />
      </PlansListChrome>
      <SipIdealBody />
      <SipPlansFooter />
    </>
  )
}
